import { internalUsersDomains } from './internal-users-domains'

export function isDomainInternal(email: string) {
  return internalUsersDomains.some((domain) => email.endsWith(domain))
}
